import {
  combineReducers
} from 'redux'
import {
  FOOD,
  POPULAR_FOOD,
  FOOD_DETAILS
} from '../../actions/actionTypes'
import {
  fetchingData,
  initStateLang
} from '../../utils'

const initailState = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}

const list = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case FOOD.REQUEST:
    return {
      ...state,
      loading: true,
      error: '',
    }
  case FOOD.SUCCESS:
    return {
      ...state,
      loading: false,
      error: '',
      [action.lang]: { data: action.data, lastUpdate: action.lasted }
    }
  case FOOD.FAILURE:
    return {
      ...state,
      loading: false,
      error: action.error,
    }
  default:
    return state
  }
}
const popular = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case POPULAR_FOOD.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case POPULAR_FOOD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case POPULAR_FOOD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateDetail = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}
const details = (state = initStateLang(initailStateDetail, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case FOOD_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        [action.lang]: { data: {} }
      }
    case FOOD_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case FOOD_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
export default combineReducers({
  list,
  popular,
  details
})


// WEBPACK FOOTER //
// ./src/containers/Food/reducer.js